import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend, 
  trendValue, 
  color = 'primary',
  isLoading = false 
}) => {
  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-error';
    return 'text-text-secondary';
  };

  return (
    <div className="bg-surface border border-border rounded-lg p-6 shadow-soft hover:shadow-elevated transition-smooth">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <div className="flex items-center space-x-3 mb-4">
            <div className={`w-12 h-12 rounded-lg bg-${color}/10 flex items-center justify-center`}>
              <Icon name={icon} size={24} className={`text-${color}`} />
            </div>
            <div>
              <h3 className="font-semibold text-text-primary">{title}</h3>
              {subtitle && (
                <p className="text-sm text-text-secondary">{subtitle}</p>
              )}
            </div>
          </div>
          
          <div className="space-y-2">
            {isLoading ? (
              <div className="animate-pulse">
                <div className="h-8 bg-muted rounded w-20"></div>
              </div>
            ) : (
              <div className="text-3xl font-bold text-text-primary">{value}</div>
            )}
            
            {trendValue && (
              <div className={`flex items-center space-x-1 ${getTrendColor()}`}>
                <Icon name={getTrendIcon()} size={16} />
                <span className="text-sm font-medium">{trendValue}</span>
                <span className="text-sm text-text-secondary">vs mes anterior</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;